
export default {
	props: {
		backButton: Object
	}
}
